// extracted by mini-css-extract-plugin
export var gray = "CountDown-module--gray--hLQ8N";
export var minutes = "CountDown-module--minutes--dQM-M";
export var minutes__text = "CountDown-module--minutes__text--s-y1R";
export var timeBlock = "CountDown-module--timeBlock--BZQXi";
export var timeList = "CountDown-module--timeList--EytJR";
export var timesContainer = "CountDown-module--timesContainer--vpisD";
export var white = "CountDown-module--white--6Rtrn";